import axios from "../utils/axios.wrapper";

// Get all sales
export const getAllSales = async () => {
  const { data } = await axios.get("/sale");
  return data;
};

// Get active sales
export const getActiveSales = async () => {
  const { data } = await axios.get("/sale/active");
  return data.items || data;
};

// Get inactive sales
export const getInactiveSales = async () => {
  const { data } = await axios.get("/sale/inactive");
  return data.items || data;
};

// Get sale by ID (includes saleLines and payments)
export const getSaleById = async (id) => {
  const { data } = await axios.get(`/sale/${id}`);
  return data;
};

// Get sales by customer
export const getSalesByCustomer = async (customerId) => {
  const { data } = await axios.get(`/sale/customer/${customerId}`);
  return data.items || data;
};

// Get sales by customer name
export const getSalesByCustomerName = async (name) => {
  const { data } = await axios.get(`/sale/customer/by-name/${name}`);
  return data.items || data;
};

// Get sales by date range
export const getSalesByDateRange = async (startDate, endDate) => {
  const { data } = await axios.post("/sale/daterange", { startDate, endDate });
  return data.items || data;
};

// Get sales paginated
export const getSalesPaginated = async (filter) => {
  const { data } = await axios.post("/sale/paginate", filter);
  return data;
};

// Create new sale
// saleData includes: sale info + saleLines array + payments array
export const createSale = async (saleData) => {
  const { data } = await axios.post("/sale/create", saleData);
  return data;
};

// Transform sale to invoice
export const transformSaleToInvoice = async (ids, includesFiscalTimber = false) => {
  const { data } = await axios.post(`/sale/to-invoice/${includesFiscalTimber}`, ids);
  return data;
};


// Update sale
// saleData includes: sale info + saleLines array + payments array
// export const updateSale = async (id, saleData) => {
//   const { data } = await axios.put(`/sale/${id}`, saleData);
//   return data;
// };

export const updateSale = async (id, saleData) => {

  const { data } = await axios.put(
    `/sale/${id}`, 
    saleData,
    {
      headers: {
        'Content-Type': 'application/json', //  Force explicite
      },
    }
  );
  return data;
};

// Soft delete sale
export const deleteSale = async (id) => {
  const { data } = await axios.delete(`/sale/${id}`);
  return data;
};

// Hard delete sale
export const hardDeleteSale = async (id) => {
  const { data } = await axios.delete(`/sale/hard/${id}`);
  return data;
};

// Hard delete sale
export const cancelSale = async (id) => {
  const { data } = await axios.delete(`/sale/cancel/${id}`);
  return data;
};

// Search sales (if needed - using customer name search for now)
export const searchSales = async (query) => {
  return await getSalesByCustomerName(query);
};

export const addPaymentsToSales = async (dto) => {
  const { data } = await axios.post('/sale/payments', dto);
  return data;
};

export const saleService = {
  getAllSales,
  getActiveSales,
  getInactiveSales,
  getSaleById,
  getSalesByCustomer,
  getSalesByCustomerName,
  getSalesByDateRange,
  getSalesPaginated,
  createSale,
  updateSale,
  deleteSale,
  hardDeleteSale,
  searchSales,
  transformSaleToInvoice,
  cancelSale,
  addPaymentsToSales
};
